var React = require('react');

function UiArrowCircleLeft (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"ui-arrow-hollow"),React.createElement("g",{"key":1},[React.createElement("path",{"d":"M23,0A23,23,0,1,0,46,23,23,23,0,0,0,23,0ZM34,24H14.41l4.3,4.29a1,1,0,0,1,0,1.42,1,1,0,0,1-1.42,0l-6-6a1,1,0,0,1-.21-.33.94.94,0,0,1,0-.76,1,1,0,0,1,.21-.33l6-6a1,1,0,0,1,1.42,1.42L14.41,22H34a1,1,0,0,1,0,2Z","key":0}),React.createElement("path",{"className":"fill-override","d":"M34,22H14.41l4.3-4.29a1,1,0,0,0-1.42-1.42l-6,6a1,1,0,0,0-.21.33.94.94,0,0,0,0,.76,1,1,0,0,0,.21.33l6,6a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42L14.41,24H34a1,1,0,0,0,0-2Z","style":{"fill":"none"},"key":1})])]);
}

UiArrowCircleLeft.defaultProps = {"role":"presentation","data-name":"Layer 1","viewBox":"0 0 46 46"};

module.exports = UiArrowCircleLeft;

UiArrowCircleLeft.default = UiArrowCircleLeft;
